export enum AuthStatus {
    SUCCESS = 'authorize',
    ERROR = 'not-authorize',
}
export interface RefreshTokenInput {
  token: string;
  refreshToken: string;
}